export const RESEND_INDICATION_TTL = 8000;
export const RESEND_INDICATION_TTL_TIMER = 30000;

export const EXPERIMENTS = {
  SHOULD_SHOW_RESEND_TIMER: 'specs.ident.shouldShowResendTimer',
  CREATE_PASSWORD_OFFER: 'specs.ident.createPasswordOffer',
  TWO_FA_AGGRESSIVE_OFFER: 'specs.ident.2faAggresiveOffer',
};
